function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtistIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m284.38 328.12c60.406 0 109.38-48.969 109.38-109.38s-48.969-109.38-109.38-109.38-109.38 48.969-109.38 109.38 48.969 109.38 109.38 109.38z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.88 437.5c0-21.773 7.9531-41.688 21.109-57-28.594-4.9727-64.582-8.625-108.61-8.625-101.89 0-160.74 19.566-184.49 29.766-7.8828 3.3867-12.383 11.273-12.383 19.852 0 81.328 65.93 147.26 147.26 147.26h99.234c20.117 0 39.293-4.0352 56.758-11.336-11.816-14.918-18.875-33.777-18.875-54.289z",
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m546.88 338.78c19.676 6.4727 42.461 11.223 65.625 11.223v-43.75c-28.461 0-57.891-9.6523-77.719-19.566l-31.656-15.828v148.5c-6.8438-2.418-14.207-3.7344-21.875-3.7344-36.246 0-65.625 29.379-65.625 65.625s29.379 65.625 65.625 65.625 65.625-29.379 65.625-65.625z",
    style: {
      fill: "#ffffff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtistIcon);
export default __webpack_public_path__ + "static/media/artist_icon.4caf4bb39b296be0fbedac17f105ed58.svg";
export { ForwardRef as ReactComponent };